import LoadingScreen from "../components/LoadingScreen";
import SessionRecovery from "../components/SessionRecovery";
import { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../components/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading, authError } = useContext(AuthContext);

  if (loading) return <LoadingScreen label="Checking session…" fullScreen />;

  if (!user && authError) return <SessionRecovery />;

  if (!user) return <Navigate to="/login" replace />;

  return children;
}